export const ADD_NOTES = "ADD_NOTES";
export const ADD_LOCATION = "ADD_LOCATION";
export const ADD_URLS = "ADD_URLS";
export const DELETE_NOTES = "DELETE_NOTES";
export const DELETE_LOCATION = "DELETE_LOCATION";
